module.exports = __webpack_public_path__ + "img/culture_08.0d939b70.png";